/* global Swiper */
// *******************************************************************************
// 1.0 - Sleeping profile cards
// *******************************************************************************

const sleepingProfileCardsSliderEle = document.querySelectorAll('[data-slider="sleeping-profile-cards-slider"]');

const sleepingProfileCardsOptions = {
  slidesPerView: 1.4,
  spaceBetween: 8,
  speed: 1000,
  watchOverflow: true,
  freeMode: true,
  breakpoints: {
     360: {
      slidesPerView: 2.4,
     spaceBetween: 8,
    },
     767: {
      slidesPerView: 3.3,
      spaceBetween: 10,
    },
    1023: {
      freeMode: false,
      slidesPerView: 'auto',
      spaceBetween: 0,
    },
  },
};

sleepingProfileCardsSliderEle.forEach((el) =>  new Swiper(el, sleepingProfileCardsOptions));
